import * as Yup from "yup"

const boxesRegExp = /^[1-9]{2}$/

const phoneRegExp = /^5[0-9]{8}$/
export const validationObject: any = {
  // Name Required Keyword - laundry.form.validations.name.required
  name: Yup.string().required("სახელი აუცილებელია"),
  logo: Yup.string().required("ლოგო აუცილებელია"),
  address: Yup.string().required("მისამართი აუცილებელია"),
  phone: Yup.string()
    .required("ტელეფონი აუცილებელია")
    .matches(phoneRegExp, "არასწორი ფორმატი"),
  // Boxes Required Keyword - laundry.form.validations.boxes.required
  // Boxes Range Keyword - laundry.form.validations.boxes.invalid
  boxes: Yup.number()
    .nullable()
    .required("ბოქსების რაოდენობა აუცილებელია")
    .min(1, "გთხოვთ მიუთითოს რიცხვი 1-99 შუალედში")
    .max(99, "გთხოვთ მიუთითოს რიცხვი 1-99 შუალედში"),
  district: Yup.string().nullable().required("უბანი აუცილებელია"),
  email: Yup.string().email("არასწორი ფორმატი"),
}
export const QAPPValidationObject: any = {
  // Name Required Keyword - laundry.form.validations.name.required
  name: Yup.string().required("სახელი აუცილებელია"),
  logo: Yup.string().required("ლოგო აუცილებელია"),
  address: Yup.string().required("მისამართი აუცილებელია"),
  phone: Yup.string()
    .required("ტელეფონი აუცილებელია")
    .matches(phoneRegExp, "არასწორი ფორმატი"),
  // Boxes Required Keyword - laundry.form.validations.boxes.required
  // Boxes Range Keyword - laundry.form.validations.boxes.invalid
  boxes: Yup.number()
    .nullable()
    .required("ბოქსების რაოდენობა აუცილებელია")
    .min(1, "გთხოვთ მიუთითოს რიცხვი 1-99 შუალედში")
    .max(99, "გთხოვთ მიუთითოს რიცხვი 1-99 შუალედში"),
  district: Yup.string().nullable().required("უბანი აუცილებელია"),
  email: Yup.string().email("არასწორი ფორმატი"),
}
export const getLaundryValidationSchema = (
  T: unknown,
  isQappUser: boolean | null,
) => {
  return Yup.object(isQappUser ? QAPPValidationObject : validationObject)
}
